import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { PAGE_ROUTES, Roles } from "../utils/constants";
import ProtectedRoute from "../components/protectedRoute/ProtectedRoute";
import { UserManagement } from "./userManagement/UserManagement";
import { Organization } from "./organization/Organization";
import { TrainAndContent } from "./trainAndContent/content/Content";
import UserRole from "./userRole/UserRole";
import { Custom } from "./trainAndContent/custom/Custom";
import BroadcastTemplate from "./broadcast/broadcastTemplate/BroadcastTemplate";
import { isAnalyticsGet, isBroadcastAdd, isBroadcastDelete, isBroadcastEdit, isBroadcastGet, isChatGet, isIntegrationGet, isOrganization, isOrganizationalAppGet, isProfileGet, isTrainAndContentGet, isUserManagementGet, isUserRoleGet } from "../utils/permissions";

const Chat = React.lazy(() => import("./chatPage/ChatPage"));
const IntegrationPage = React.lazy(() => import("./integration/Integration"));
const Settings = React.lazy(() => import("./settings/Settings"));
const PrivacyPolicy = React.lazy(() => import("./privacyPolicy/PrivacyPolicy"));
const Analytics = React.lazy(() => import("./Analytics/Analytics"));
const Actions = React.lazy(() => import("./Analytics/Actions/Actions"));
const Billing = React.lazy(() => import("./billing/Billing"));
const Invoices = React.lazy(() => import("./billing/invoice/Invoices"));
const InvoicesApproval = React.lazy(() =>
  import("./billing/invoiceApproval/InvoicesApproval")
);
const Error = React.lazy(() => import("../components/NotFound/PageNotFound"));
const Login = React.lazy(() => import("./login/Login"));
const Redirect = React.lazy(() => import("../components/redirect/Redirect"));
const SendMessage = React.lazy(() =>
  import("./broadcast/sendMessage/SendMessage")
);
const ScheduledMessages = React.lazy(() =>
  import("./broadcast/scheduledMessages/ScheduledMessages")
);
const BroadcastAnalytics = React.lazy(() =>
  import("./broadcast/broadcastAnalytics/BroadcastAnalytics")
);
const UserGroups = React.lazy(() =>
  import("./broadcast/userGroups/UserGroups")
);

const routes = createBrowserRouter([
  {
    path: "/",
    element: <Redirect />,
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.CHAT,
    element: (
      <ProtectedRoute hasPermission={isChatGet}>
        <Chat />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.INTEGRATION,
    element: (
      <ProtectedRoute hasPermission={isIntegrationGet}>
        <IntegrationPage />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.SETTINGS,
    element: (
      <ProtectedRoute hasPermission={isProfileGet}>
        <Settings />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    // old bookmarks / links
    path: PAGE_ROUTES.PROFILE,
    element: <Navigate to={PAGE_ROUTES.SETTINGS} replace />,
    SideNav: false,
  },
  {
    path: PAGE_ROUTES.PRIVACY_POLICY,
    element: <PrivacyPolicy />,
    SideNav: false,
    SideNavWhenAuthenticated: true,
  },
  {
    path: PAGE_ROUTES.ANALYTICS,
    element: (
      <ProtectedRoute hasPermission={isAnalyticsGet}>
       <Actions />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  // { repated code this is now render on PAGE_ROUTES.ANALYTICS this route
  //   path: PAGE_ROUTES.ANALYTICS_ACTIONS,
  //   element: (
  //     <ProtectedRoute>
  //       <Actions />
  //     </ProtectedRoute>
  //   ),
  //   SideNav: true,
  // },
  // {
  //   path: PAGE_ROUTES.BILLING,
  //   element: (
  //     <ProtectedRoute>
  //       <Billing />
  //     </ProtectedRoute>
  //   ),
  //   SideNav: true,
  // },
  {
    path: PAGE_ROUTES.BILLING_INVOICE,
    element: (
      <ProtectedRoute>
        <Invoices />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.BILLING_INVOICE_APPROVAL,
    element: (
      <ProtectedRoute>
        <InvoicesApproval />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  // {
  //   path: PAGE_ROUTES.DASHBOARD, // This was a old page which has now been used as  <Actions />
  //   element: (
  //     <ProtectedRoute>
  //       <Analytics />
  //     </ProtectedRoute>
  //   ),
  //   SideNav: true,
  // },
  {
    path: PAGE_ROUTES.USER_MANAGEMENT,
    element: (
      <ProtectedRoute hasPermission={isUserManagementGet}>
        <UserManagement />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.ORGANIZATION,
    element: (
      <ProtectedRoute hasPermission={isOrganizationalAppGet || isOrganization === Roles.SUPER_ADMIN}>
        <Organization />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.CONTENT,
    element: (
      <ProtectedRoute hasPermission={isTrainAndContentGet}>
        <TrainAndContent />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  // {
  //   path: PAGE_ROUTES.CUSTOM,
  //   element: (
  //     <ProtectedRoute>
  //       <Custom />
  //     </ProtectedRoute>
  //   ),
  //   SideNav: true,
  // },
  {
    path: PAGE_ROUTES.USER_ROLES,
    element: (
      <ProtectedRoute hasPermission={isUserRoleGet}>
        <UserRole />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.BROADCAST_SEND_MESSAGE,
    element: (
      <ProtectedRoute hasPermission={isBroadcastAdd}>
        <SendMessage />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.BROADCAST_SCHEDULED,
    element: (
      <ProtectedRoute hasPermission={isBroadcastGet}>
        <ScheduledMessages />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.BROADCAST_ANALYTICS,
    element: (
      <ProtectedRoute hasPermission={isBroadcastGet}>
        <BroadcastAnalytics />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.BROADCAST_TEMPLATE,
    element: (
      <ProtectedRoute hasPermission={isBroadcastAdd || isBroadcastGet}>
        <BroadcastTemplate />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.BROADCAST_USER_GROUPS,
    element: (
      <ProtectedRoute hasPermission={isBroadcastEdit || isBroadcastDelete}>
        <UserGroups />
      </ProtectedRoute>
    ),
    SideNav: true,
  },
  {
    path: PAGE_ROUTES.LOGIN,
    element: <Login />,
    SideNav: false,
  },

  { path: "*", element: <Error />, SideNav: false },
]);

export default routes;
